import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import { images } from '../../components/shared/assets';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { useOverlayManager } from '../../contexts/OverlayContext';
import './GalleryPatagonia.css';

// Patagonia-specific gallery images (using local assets)
const patagoniaGalleryImages = [
  { src: '/assets/images/gallery-patagonia-landscape.png', alt: 'Patagonia Landscape' },
  { src: '/assets/images/destinationsPatagonia.png', alt: 'Awasi Patagonia Lodge' },
  { src: '/assets/images/packageCollage1.png', alt: 'Mountain Vista' },
  { src: '/assets/images/packageCollage2.png', alt: 'Lake View' },
  { src: '/assets/images/packageCollage3.png', alt: 'Forest Trail' },
  { src: '/assets/fullviewportpatagonia.jpg', alt: 'Awasi Patagonia Villa' },
  { src: '/assets/patagonia-factsheet-hero.jpg', alt: 'Lodge Reflection' },
  { src: '/assets/experiencepagebreak.jpg', alt: 'Patagonia Experience' },
  { src: '/assets/images/video1.png', alt: 'Horseback Riding' },
  { src: '/assets/images/video2.png', alt: 'Mountain Hiking' },
  { src: '/assets/images/video3.png', alt: 'Lake Excursion' },
  { src: '/assets/images/video4.png', alt: 'Wildlife Viewing' }
];

const GalleryPatagonia: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  // Initialize features and clear hover state
  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanup = initializeAllFeatures();
    setHoveredDestination(null);
    return cleanup;
  }, [setHoveredDestination]);

  return (
    <div className="gallery-patagonia-page">
      {/* Navigation with transparent variant for Patagonia */}
      <SmartNavigation forceVariant="transparent" />

      {/* Hero Section */}
      <div 
        className="gallery-hero-section"
        data-scroll-section="hero"
        style={{ 
          backgroundImage: `url('/assets/patagonia-factsheet-hero.jpg')`
        }}
      >
        <div className="gallery-hero-overlay">
          <h1 className="gallery-hero-title">Awaken to Unforgettable Views</h1>
          <p className="gallery-hero-subtitle">Take a seat in the front row, watching the theatre of Mother Nature unfold.</p>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="gallery-filter-bar" data-scroll-section="filters">
        <div className="gallery-filters">
          <button 
            className={`filter-button ${selectedFilter === 'patagonia' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'patagonia' ? null : 'patagonia')}
          >
            PATAGONIA +
          </button>
          <button 
            className={`filter-button ${selectedFilter === 'type' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'type' ? null : 'type')}
          >
            TYPE +
          </button>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="gallery-grid-section" data-scroll-section="gallery-grid">
        <div className="gallery-grid">
          {patagoniaGalleryImages.map((image, index) => (
            <div 
              key={index} 
              className={`gallery-item gallery-item--${(index % 4) + 1}`}
              data-scroll-animation="fade-up"
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Instagram Section */}
      <div data-scroll-section="instagram">
        <InstagramSection 
          title="Follow us on Instagram @awasiexperience"
          posts={[
            { src: images.instagram1, alt: "Patagonia Instagram 1" },
            { src: images.instagram2, alt: "Patagonia Instagram 2", isVideo: true },
            { src: images.instagram3, alt: "Patagonia Instagram 3" },
            { src: images.instagram4, alt: "Patagonia Instagram 4" }
          ]}
        />
      </div>

      {/* Footer with Patagonia variant */}
      <Footer variant="patagonia" />
    </div>
  );
};

export default GalleryPatagonia;